import { genericAsResultHeader, parseModel } from 'lbs-pi-platform-access/es/utils';

export function LegacyAnnotationProvider (provider) {
  this.putAnnotations3 = (rawXml) => {
    return provider.request({
      methodName: 'PutAnnotations3',
      xmlProcessor: xml => {
        return xml.replace('</Token>', `</Token>${rawXml}`);
      },
      parseResponseDelegate (raw) {
        return parseModel(raw, {
          result: {
            path: 'PutAnnotations3Result[0]',
            model: genericAsResultHeader
          },
          // Normally we parse the data more precisely but let's keep the structure as close to the original to simplify
          // integration with legacy annotations code
          response: (raw) => raw
        });
      }
    });
  };
}



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/annotations/LegacyAnnotationProvider.js